import { createApp } from 'vue';
import { createPinia } from 'pinia';
import VueDragscroll from 'vue-dragscroll';
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

import router from '@/router';

import App from './App.vue';
import './index.css';

import Glue from './glue-event-handlers';
import { useConnectionStore } from '@/stores/connection';
import { useRootStore } from '@/stores/root';
import { createGettext } from 'vue3-gettext';
Glue();

const gettext = createGettext({
  availableLanguages: {
    en: 'English',
  },
  defaultLanguage: 'en',
});

const app = createApp(App);

app.use(gettext);
app.use(createPinia()).use(router);
app.use(VueDragscroll);
app.use(Toast, {
  position: POSITION.TOP_RIGHT,
  timeout: 3000,
});
const rootStore = useRootStore();
const connectionStore = useConnectionStore();
connectionStore.init({ apiBase: rootStore.apiBase });
connectionStore.initAttachmentsClient();

app.mount('#vp-app-new');
